export function formatLocalDateTime(dt?: string | null): string {
  if (!dt) return '-'
  let s = String(dt)
  // If string lacks timezone info (no 'Z' or +hh:mm/-hh:mm), assume UTC and append 'Z'
  if (!/[zZ]|[+\-]\d{2}:?\d{2}/.test(s)) {
    s = s + 'Z'
  }
  const d = new Date(s)
  if (isNaN(d.getTime())) return '-'
  return d.toLocaleString()
}

export function formatLocalDateTimeNoSeconds(dt?: string | null): string {
  if (!dt) return '-'
  let s = String(dt)
  // If string lacks timezone info (no 'Z' or +hh:mm/-hh:mm), assume UTC and append 'Z'
  if (!/[zZ]|[+\-]\d{2}:?\d{2}/.test(s)) {
    s = s + 'Z'
  }
  const d = new Date(s)
  if (isNaN(d.getTime())) return '-'
  // Format without seconds
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export default { formatLocalDateTime, formatLocalDateTimeNoSeconds }
